import React from "react";
import {
    Home,
    Menu,
    Offers,
    Cart,
    BestSeller,
    HomeActive,
    MenuActive,
    OffersActive,
    CartActive,
    BestSellerActive

} from "../../assets/icons/icons";
import { NavLink } from "react-router-dom";
export default function Footer() {
    return (
        <footer className="fixed bottom-0 w-full z-[100]">
            <div className="container flex items-center justify-center bg-white h-[93px] p-[15px] rounded-t-[20px]">
                <nav className="w-full">
                    <ul className="w-full h-full flex items-center justify-around gap-[10px]">
                        <li>
                            <NavLink
                                to="/"
                                className={({ isActive }) =>
                                    isActive
                                        ? "w-[50px] h-[50px] flex items-center justify-center rounded-full bg-[#20BCB4] transition-all duration-300"
                                        : "w-[50px] h-[50px] flex items-center justify-center bg-white shadow rounded-full"
                                }
                            >
                                {({ isActive }) => isActive ? <HomeActive /> : <Home />}
                            </NavLink>
                        </li>

                        <li>
                            <NavLink
                                to="/menu"
                                className={({ isActive }) =>
                                    isActive ? "w-[50px] h-[50px] flex items-center justify-center rounded-full bg-[#20BCB4] transition-all duration-300" : "w-[50px] h-[50px] flex items-center justify-center bg-white shadow rounded-full"
                                }
                            >
                                {({ isActive }) => isActive ? <MenuActive /> : <Menu />}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/cart"
                                className={({ isActive }) =>
                                    isActive ? "w-[50px] h-[50px] flex items-center justify-center rounded-full bg-[#20BCB4] transition-all duration-300" : "w-[50px] h-[50px] flex items-center justify-center bg-white shadow rounded-full"
                                }
                            >
                                {({ isActive }) => isActive ? <CartActive /> : <Cart />}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/offers"
                                className={({ isActive }) =>
                                    isActive ? "w-[50px] h-[50px] flex items-center justify-center rounded-full bg-[#20BCB4] transition-all duration-300" : "w-[50px] h-[50px] flex items-center justify-center bg-white shadow rounded-full"
                                }
                            >
                                {({ isActive }) => isActive ? <OffersActive /> : <Offers />}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/bestSeller"
                                className={({ isActive }) =>
                                    isActive ? "w-[50px] h-[50px] flex items-center justify-center rounded-full bg-[#20BCB4] transition-all duration-300" : "w-[50px] h-[50px] flex items-center justify-center bg-white shadow rounded-full"
                                }
                            >
                                {({ isActive }) => isActive ? <BestSellerActive /> : <BestSeller />}
                            </NavLink>
                        </li>
                    </ul>
                </nav>
            </div>
        </footer>
    );
}